import { useParams } from 'react-router-dom';

/**
 * Like useParams().id but strips trailing dots, whitespace and other
 * non-hex chars that can sneak in from copy-pasted URLs.
 * Returns `undefined` when the param is absent.
 */
export function useSanitizedId(param = 'id'): string | undefined {
  const params = useParams();
  const raw = params[param];
  if (!raw) return undefined;
  // Trim trailing chars that aren't valid in a UUID (hex + dashes)
  return raw.replace(/[^a-fA-F0-9-]+$/, '');
}
